<template>
  <div class="risk-page">
    <!-- ============ 品牌头部 ============ -->
    <header class="sub-header">
      <div class="sub-header-inner">
        <button type="button" class="back-btn" aria-label="返回" @click="goBack">
          <van-icon name="arrow-left" />
        </button>
        <h1 class="sub-title">风控报告</h1>
      </div>
    </header>

    <main class="page-content">
      <p class="page-lead">输入企业全称，即时交叉核验工商、司法与经营异常信息并生成风控报告。</p>

      <!-- 企业全称查询 -->
      <section class="surface-section query-section">
        <header class="section-heading">
          <h2>企业全称查询</h2>
          <span></span>
        </header>
        <div class="query-box">
          <van-icon name="search" class="q-icon" />
          <input v-model="companyName"
                 type="text"
                 placeholder="输入企业全称，即时生成风控报告"
                 @keyup.enter="queryReport" />
          <button type="button" class="query-btn" @click="queryReport">立即查询</button>
        </div>

        <!-- 进度展示 -->
        <div class="running-report" v-if="runningReport">
          <div class="run-head">
            <span class="run-name">{{ runningReport.company }}</span>
            <span class="run-status" :class="{ done: runningReport.progress >= 100 }">{{ runningReport.progress >= 100 ? '已生成' : '生成中' }}</span>
          </div>
          <div class="run-bar">
            <div class="run-bar-fill" :style="{ width: runningReport.progress + '%' }"></div>
          </div>
          <div class="run-foot">
            <p class="run-tip">{{ runningReport.progress >= 100 ? '报告已生成，可点击下载' : '正在交叉核验工商、司法、经营异常数据…' }}</p>
            <button v-if="runningReport.progress >= 100" type="button" class="run-download" @click="simDownload(runningReport.company + ' 风控报告')">
              下载<van-icon name="arrow" />
            </button>
          </div>
        </div>
      </section>

      <!-- 最近查询历史 -->
      <section class="surface-section history-section">
        <header class="section-heading">
          <h2>最近查询历史</h2>
          <span></span>
        </header>
        <ul class="history-list" v-if="riskHistory.length">
          <li v-for="(item, i) in riskHistory" :key="i" class="h-row">
            <div class="h-main">
              <h3>{{ item.company }}</h3>
              <p class="h-time">{{ item.time }}</p>
            </div>
            <span class="status-tag" :class="item.status === '已生成' ? 'done' : 'run'">{{ item.status }}</span>
            <button v-if="item.status === '已生成'" type="button" class="dl-link" @click="simDownload(item.company + ' 风控报告')">下载</button>
          </li>
        </ul>
        <div class="history-empty" v-else>暂无查询记录</div>
      </section>
    </main>
  </div>
</template>

<script>
import guoqiShare from '../utils/guoqiShare'
import pageAccess from '../utils/pageAccess'
export default {
  name: 'guoqiRisk',
  mixins: [guoqiShare, pageAccess],
  data () {
    return {
      // 页面访问日志：页面名称
      pageName: '风控报告',
      // 微信分享：链接为当前路由
      shareTitle: '企业风控报告：一键生成贸易对手风险画像',
      shareDesc: '交叉核验工商、司法、经营异常数据，实时生成企业风控报告',
      companyName: '',
      runningReport: null,
      riskTimer: null,
      riskHistory: [
        { company: '国家能源集团有限责任公司', time: '10 分钟前', status: '已生成' },
        { company: '中国建筑集团有限公司', time: '1 小时前', status: '已生成' },
        { company: '中国中车股份有限公司', time: '昨天', status: '已生成' }
      ]
    }
  },
  beforeDestroy () {
    clearInterval(this.riskTimer)
  },
  methods: {
    goBack () {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/guoqi')
      }
    },
    // 即时生成风控报告：进度模拟（与 guoqi 首页行为一致）
    queryReport () {
      const name = this.companyName.trim()
      if (!name) {
        this.$toast('请输入企业全称')
        return
      }
      if (this.runningReport && this.runningReport.progress < 100) {
        this.$toast('已有报告正在生成，请稍候')
        return
      }
      const item = { company: name, time: '刚刚', status: '生成中', progress: 0, running: true }
      this.riskHistory.unshift(item)
      this.runningReport = item
      this.companyName = ''
      clearInterval(this.riskTimer)
      this.riskTimer = setInterval(() => {
        item.progress = Math.min(item.progress + 9, 100)
        if (item.progress >= 100) {
          clearInterval(this.riskTimer)
          item.status = '已生成'
          item.running = false
          this.$toast.success('风控报告已生成')
        }
      }, 130)
    },
    simDownload (label) {
      this.$toast.loading({ message: '正在生成 ' + label + ' …', duration: 0, forbidClick: true })
      setTimeout(() => {
        this.$toast.clear()
        this.$toast.success('已开始下载')
      }, 900)
    }
  }
}
</script>

<style lang="less" scoped>
@page-bg: #faf7f1;
@surface: #fffdfc;
@ink: #142033;
@body: #333a45;
@muted: #7f858d;
@brand: #ef4f16;
@brand-light: #f47a3c;
@brand-soft: #fff1e8;
@gold: #d7a34a;
@line: #e9e6e1;
@warn: #d97706;
@warn-bg: #fcf0dc;

button { margin: 0; padding: 0; border: 0; color: inherit; font: inherit; background: transparent; appearance: none; }
ul { margin: 0; padding: 0; list-style: none; }

.risk-page { min-height: 100vh; box-sizing: border-box; color: @ink; background: @page-bg; font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif; }

/* ================= 品牌头部 ================= */
.sub-header { position: sticky; top: 0; z-index: 20; background: rgba(250, 247, 241, 0.94); backdrop-filter: blur(6px); -webkit-backdrop-filter: blur(6px); border-bottom: 1px solid @line; }
.sub-header-inner { position: relative; display: flex; align-items: center; max-width: 750px; height: 88px; margin: 0 auto; padding: 0 24px; box-sizing: border-box; }
.back-btn { display: inline-flex; align-items: center; justify-content: center; width: 60px; height: 60px; color: @ink; cursor: pointer; }
.back-btn .van-icon { font-size: 38px; }
.sub-title { position: absolute; right: 24px; left: 24px; margin: 0; color: @ink; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 34px; font-weight: 700; letter-spacing: 1px; line-height: 88px; text-align: center; pointer-events: none; }

/* ================= 页面主体 ================= */
.page-content { max-width: 750px; margin: 0 auto; padding: 0 0 56px; }
.page-lead { margin: 0; padding: 30px 40px 0; color: @body; font-size: 24px; line-height: 1.7; }

/* ================= 编辑式区块标题 ================= */
.section-heading {
  display: flex;
  align-items: center;
  h2 { margin: 0; color: @ink; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 35px; font-weight: 700; line-height: 1; }
  span { width: 34px; height: 5px; margin-left: 18px; border-radius: 3px; background: @brand; }
}

/* ================= 内容面 ================= */
.surface-section { margin-top: 30px; padding: 32px 40px 10px; background: @surface; border-top: 1px solid @line; border-bottom: 1px solid @line; }

/* ================= 查询框 ================= */
.query-box { display: flex; align-items: center; box-sizing: border-box; height: 64px; margin-top: 26px; padding: 0 10px 0 22px; background: @page-bg; border: 1px solid @line; border-radius: 32px; }
.q-icon { flex: 0 0 auto; color: @muted; font-size: 28px; }
.query-box input { flex: 1; min-width: 0; height: 100%; margin-left: 12px; border: none; outline: none; background: transparent; color: @ink; font-family: inherit; font-size: 26px; }
.query-box input::placeholder { color: #a9aeb5; }
.query-btn { flex: 0 0 auto; box-sizing: border-box; height: 50px; padding: 0 26px; margin-left: 14px; color: #fff; font-size: 24px; font-weight: 600; border-radius: 25px; background: linear-gradient(90deg, @brand, @brand-light); box-shadow: 0 6px 14px rgba(239, 79, 22, 0.18); cursor: pointer; }

/* ================= 生成进度 ================= */
.running-report { margin-top: 26px; padding: 24px; background: @page-bg; border: 1px solid @line; border-radius: 16px; }
.run-head { display: flex; align-items: center; gap: 12px; }
.run-name { flex: 1; min-width: 0; color: @ink; font-size: 27px; font-weight: 700; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
.run-status { flex: 0 0 auto; padding: 4px 14px; border-radius: 999px; font-size: 20px; font-weight: 600; color: @warn; background: @warn-bg; }
.run-status.done { color: #0f9d5c; background: #e3f7ec; }
.run-bar { height: 8px; margin-top: 18px; border-radius: 999px; background: rgba(239, 79, 22, 0.12); overflow: hidden; }
.run-bar-fill { height: 100%; border-radius: 999px; background: linear-gradient(90deg, @brand, @brand-light); transition: width 0.13s linear; }
.run-foot { display: flex; align-items: center; margin-top: 16px; }
.run-tip { flex: 1; min-width: 0; margin: 0; color: @muted; font-size: 21px; }
.run-download { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 6px; color: @brand; font-size: 22px; font-weight: 600; cursor: pointer; }
.run-download .van-icon { font-size: 20px; }

/* ================= 查询历史 ================= */
.history-section { padding-bottom: 6px; }
.history-list { margin-top: 10px; }
.h-row { display: flex; align-items: center; padding: 26px 0; border-bottom: 1px solid @line; }
.h-row:last-child { border-bottom: none; }
.h-main { flex: 1; min-width: 0; }
.h-main h3 { margin: 0; color: @ink; font-size: 27px; font-weight: 700; line-height: 1.4; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
.h-time { margin: 7px 0 0; color: @muted; font-size: 20px; }
.status-tag { flex: 0 0 auto; margin-left: 16px; padding: 5px 14px; border-radius: 999px; font-size: 20px; font-weight: 600; }
.status-tag.done { color: @brand; background: @brand-soft; }
.status-tag.run { color: @warn; background: @warn-bg; }
.dl-link { flex: 0 0 auto; margin-left: 20px; color: @brand; font-size: 22px; font-weight: 600; cursor: pointer; }
.history-empty { padding: 44px 0; color: @muted; font-size: 23px; text-align: center; }

@media (max-width: 420px) {
  .sub-header-inner { height: 78px; padding: 0 14px; }
  .sub-title { right: 14px; left: 14px; font-size: 30px; line-height: 78px; }
  .page-lead { padding: 24px 22px 0; font-size: 21px; }
  .surface-section { padding: 26px 22px 8px; }
  .query-btn { padding: 0 20px; font-size: 22px; }
  .run-name { font-size: 24px; }
  .run-tip { font-size: 18px; }
  .h-main h3 { font-size: 24px; }
  .h-time, .status-tag { font-size: 17px; }
  .dl-link { font-size: 20px; }
}
</style>
